const triggerChangeEvent = (element, options = {}) => {
  const event = new Event('change', options);
  element.dispatchEvent(event);
};

export default triggerChangeEvent;
